import type { ClientPropertyItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	type PortfolioTileTrailing,
	TILE_SECONDARY_KIND,
} from "web_myplann/Portfolio/Helpers/getPortfolioTileTrailing";
import { propertyNumericValue } from "web_myplann/Portfolio/Helpers/propertyNumericValue";

export const getPropertyTileTrailing = (
	data: ClientPropertyItemResponseDTO,
): PortfolioTileTrailing => {
	const value = propertyNumericValue(data);
	const percent = data.evaluationPercent;
	return {
		primary: value === null ? null : { amount: value },
		secondary:
			percent === null || percent === undefined
				? null
				: { kind: TILE_SECONDARY_KIND.evaluation, percent },
		isMissingValue: value === null,
	};
};
